 <template>
  <div class="ChallengesAssociateTechnique">
    <div class="container-fluid">
      <associate-technique-search-bar @showList="updateShowAssociatedTechniqueListFlag" @selectedChallengeObj="selectedChallengeObj" @parseTechniqueResponse="updatedparseTechniqueResponse"></associate-technique-search-bar>  
      <associate-techniques-details v-if="showAssociatedTechniqueList" v-bind:challengeObj="challengeObj" v-bind:parseTechniqueResponse="parsedTechniqueResp" v-bind:showParsedTechniqueResp="showParsedTechniqueResp"></associate-techniques-details>
    </div>
  </div>
</template>
<script>
import AssociateTechniqueSearchBar from '@/components/ChallengesAssociateTechniquesSearchBar'
import AssociateTechniquesDetails from '@/components/AssociateTechniquesDetails'
export default {
  created: function () {},
  data: function () {
    return {
      showAssociatedTechniqueList: false,
      challengeObj: null,
      parsedTechniqueResp: null,
      showParsedTechniqueResp: false
    }
  },
  methods: {
    updateShowAssociatedTechniqueListFlag (value) {
      this.showAssociatedTechniqueList = value
    },
    selectedChallengeObj (value) {
      this.showParsedTechniqueResp = true
      this.challengeObj = value
    },
    updatedparseTechniqueResponse (value) {
      // AK: Used to show user parsed technique response
      this.showAssociatedTechniqueList = true
      this.parsedTechniqueResp = value
      this.showParsedTechniqueResp = true
    }
  },
  computed: {
    getParsedTechniqueRespValue: {
      get: function () {
        return this.parsedTechniqueResp
      }
    }
  },
  components: {
    'associate-technique-search-bar': AssociateTechniqueSearchBar,
    'associate-techniques-details': AssociateTechniquesDetails
  },
  name: 'ChallengesAssociateTechnique'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.ManageCourseDetailList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.tdMargin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-left-2Point7Perc
{
	margin-left: 2.7%;
}
 .margin-right-1Point1Perc
{
	margin-right: 1.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.text-align-center {
 text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.imgWidthHeight{
  width:180px; 
  height:110px;
}
.padding-Top-1Perc{
  padding-Top:1%;
}
.padding-top-2Perc {
  padding-top: 2% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color{
  color:#2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/ChallengesAssociateTechniques.vue